











import { Component, Model, Mixins, Watch } from 'vue-property-decorator';
import FormMixin from '../../../common/mixins/formMixin';
import { FitIcon } from '@tencent/wphk-ui';

@Component({
  components: {
    FitIcon,
  },
})
export default class FitCheckbox extends Mixins(FormMixin) {
  @Model('change') value;
  @Watch('value')
  onValueChange() {
    this.notify('change', this.value);
  }
}
